import ApiService from './ApiService'

class UserGroupService {
  createGroup = async (apiToken, options) => {
    var url = '/api/usergroup'

    var params = {}

    try {
      var result = await ApiService.post(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  getGroups = async (apiToken, params, where) => {
    var url = '/api/usergroup'

    if (where) {
      params.where = where
    }

    params.limit = 1000

    try {
      var groups = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return groups
  }
}
export default new UserGroupService()
